export default "__VITE_ASSET__sOQ2HcW9__"